<template>

    <div class="alerts">
        <transition-group name="alert">
            <v-alert-container v-for="alert in alerts" :key="alert.key" :alert="alert" />
        </transition-group>
    </div>

</template>

<style scoped lang="scss">

    .alerts {
        bottom: 0;
        margin: 15px 15px 60px 15px;
        min-width: 300px;
        max-width: 600px;
        position: fixed;
        right: 0;
        width: 30%;
        z-index: 10002;
    }

</style>

<script>

import AlertContainer from '@cmp/AlertContainer';

export default {

    components: {
        'v-alert-container': AlertContainer,
    },

    computed: {

        alerts() {
            return this.$store.getters.alerts;
        },

    },

}

</script>
